// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"453":"87d02cd2","706":"3f567068"}[chunkId] + ".chunk.js";
};